import { LANG_VERSIONS } from "../constants";
import {compileCode} from '../api/axios.js';
const API_URL = "https://api.jdoodle.com/v1/execute";
export const executeCode = async (language, sourceCode) => {  
  const languageMap={"python":"python3","java":"java"}
  const codeData={language:languageMap[language],sourceCode}
  const response=await compileCode(codeData);
  console.log("jdoodleResponse",response);
  // const data = {
  //   clientId:"f86af493bf365408c7013f95e7dfe8dd",
  //   clientSecret:"4ec1fc7f23ba0f3c77335ba948610de1ef51fe06918dc61f468ae538efdcdf19",
  //   script:sourceCode,    
  //   language: "python3",
  //   versionIndex: 0,    
  // };
  // console.log("stringiefied",JSON.stringify(data));
  // const response = await fetch(API_URL, {
  //   method: "POST",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify(data),
  // });




 
  
 // return await response.json();
 return response;
};